import { render, staticRenderFns } from "./NotSubscribed.vue?vue&type=template&id=4c9fd34a&"
import script from "./NotSubscribed.vue?vue&type=script&lang=js&"
export * from "./NotSubscribed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports